import http from '../http'
import {CONTACTS_LIST, CONTACTS_CREATE, CONTACTS_EDIT} from '../../services/endpoints'

export function getContactsList() {
    return http.request({
      url:CONTACTS_LIST,
      method:'get',
    })
  }
  export function createContact(data) {
    return http.request({
      url:CONTACTS_CREATE,
      method:'post',
      data:data
    })
  }
  export function updateContact(id, data){
    return http.request({
      url:CONTACTS_EDIT(id),
      method:'put',
      data:data
    })
  }
  export function deleteContact(id){
    return http.request({
      url:CONTACTS_EDIT(id),
      method:'delete'
    })
  }